import connection from './config'

/**
 * 通过code 获取openid
 * @param code
 */
export const getOpenid = params => {
  return connection.get(`/api/v1/member/wx/openid?code=${params.code}`)
}

/**
 * 通过openid 获取登录状态
 * @param openid
 * @returns {*}
 */
export const openidLogin = (openid) => {
  return connection.request({
    url: `/api/v1/member/login/openid`,
    method: 'post',
    params: {
      openid
    }
  })
}

/**
 * 通过openid 获取注册并登陆
 * @param openid
 * @returns {*}
 */
export const openidRegisterLogin = (openid) => {
  return connection.request({
    url: `/api/v1/member/login/register/openid`,
    method: 'post',
    params: {
      openid
    }
  })
}

/**
 * 发送短信验证码
 * @param mobile 手机号
 * @returns {*}
 */
export const sendValidCode = (mobile) => {
  return connection.request({
    url: `/api/v1/member/login/sendValidCode`,
    method: 'post',
    params: {
      mobile
    }
  })
}

/**
 * 通过短信验证码登录
 * @param mobile 手机号
 * @param validCode 验证码
 * @returns {*}
 */
export const loginSms = (mobile, validCode, openid) => {
  return connection.request({
    url: `/api/v1/member/login/sms`,
    method: 'post',
    params: {
      mobile,
      validCode,
      openid
    }
  })
}
